function AppInt(props) {
    const { children } = props;
    return children;
}
export default AppInt;
